"use client";

import React, { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "Event-Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_event_partner.png"
}, {
  id: 2,
  name: "Öko-Festival",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_eco_festival.png"
}, {
  id: 3,
  name: "Stadtverwaltung",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_city_council.png"
}, {
  id: 4,
  name: "Grüner Sport",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_green_sports.png"
}, {
  id: 5,
  name: "Catering-Profis",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_catering_pro.png"
}, {
  id: 6,
  name: "Nachhaltigkeits-Zentrum",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_sustainability_hub.png"
}, {
  id: 7,
  name: "Österreichische Events",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logo_austrian_events.png"
}];
export default function PartnerShowcase() {
  const [api, setApi] = useState<CarouselApi>();
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: carouselRef,
    isVisible: isCarouselVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [api]);
  return;
}